import { ArrowRight, Scissors } from "lucide-react";
import { useSite } from "../context/SiteContentContext";

export const Hero = ({ onReserveClick }) => {
    const siteConfig = useSite();
    return (
        <section
            id="top"
            data-testid="hero-section"
            className="relative min-h-screen flex items-end overflow-hidden"
        >
            {/* Background */}
            <div className="absolute inset-0">
                <img
                    src="https://images.pexels.com/photos/17027433/pexels-photo-17027433.jpeg"
                    alt="Interior escuro de barbearia"
                    className="w-full h-full object-cover"
                    loading="eager"
                    fetchpriority="high"
                />
                <div
                    className="absolute inset-0"
                    style={{
                        background:
                            "linear-gradient(90deg, rgba(10,10,10,0.95) 0%, rgba(10,10,10,0.75) 45%, rgba(10,10,10,0.55) 100%), linear-gradient(180deg, rgba(10,10,10,0.4) 0%, rgba(10,10,10,0.2) 40%, rgba(10,10,10,0.95) 100%)",
                    }}
                />
                <div className="absolute inset-0 grain-overlay" />
            </div>

            {/* Content */}
            <div className="relative z-10 max-w-7xl mx-auto w-full px-6 md:px-12 pb-20 md:pb-32 pt-32">
                <div className="max-w-3xl fade-up">
                    <div
                        className="ornamental-divider mb-8"
                        data-testid="hero-eyebrow"
                    >
                        <span>{siteConfig.hero.eyebrow}</span>
                    </div>

                    <h1
                        className="font-display text-5xl sm:text-7xl lg:text-8xl font-black tracking-tighter leading-[0.95] text-[#f5f5f0] mb-8"
                        data-testid="hero-title"
                    >
                        {siteConfig.hero.title}
                        <br />
                        <span className="italic font-medium text-[#d4af37]">
                            {siteConfig.hero.titleAccent}
                        </span>
                    </h1>

                    <p className="font-body text-lg md:text-xl text-[#a3a3a3] max-w-xl mb-12 leading-relaxed">
                        {siteConfig.hero.subtitle}
                    </p>

                    <div className="flex flex-col sm:flex-row gap-4 items-start sm:items-center">
                        <button
                            onClick={onReserveClick}
                            data-testid="hero-reserve-btn"
                            className="group inline-flex items-center gap-3 px-8 py-4 bg-[#d4af37] text-[#0a0a0a] font-semibold tracking-wide uppercase text-sm rounded-sm hover:bg-[#b3912e] transition-all duration-300"
                        >
                            <span>Reservar horário</span>
                            <ArrowRight
                                size={18}
                                className="group-hover:translate-x-1 transition-transform duration-300"
                            />
                        </button>

                        <a
                            href="#services"
                            onClick={(e) => {
                                e.preventDefault();
                                document
                                    .querySelector("#services")
                                    ?.scrollIntoView({ behavior: "smooth" });
                            }}
                            data-testid="hero-services-btn"
                            className="inline-flex items-center gap-3 px-8 py-4 border border-[#262626] text-[#f5f5f0] font-medium tracking-wide uppercase text-sm rounded-sm hover:border-[#d4af37] hover:text-[#d4af37] transition-all duration-300"
                        >
                            <Scissors size={16} />
                            <span>Ver serviços</span>
                        </a>
                    </div>
                </div>

                {/* Stats bottom-right */}
                <div
                    className="hidden lg:flex absolute right-12 bottom-32 flex-col gap-8 border-l border-[#262626] pl-8"
                    data-testid="hero-stats"
                >
                    <div>
                        <div className="font-display text-4xl font-bold text-[#d4af37]">
                            {siteConfig.about.years}
                        </div>
                        <div className="text-xs tracking-widest uppercase text-[#737373] mt-1">
                            {siteConfig.about.yearsLabel}
                        </div>
                    </div>
                    <div>
                        <div className="font-display text-4xl font-bold text-[#d4af37]">
                            {siteConfig.about.clients}
                        </div>
                        <div className="text-xs tracking-widest uppercase text-[#737373] mt-1">
                            {siteConfig.about.clientsLabel}
                        </div>
                    </div>
                </div>
            </div>
        </section>
    );
};
